module.exports = __webpack_public_path__ + "static/media/Control_2_Thermocycler.a72c7c71.svg";